import React from 'react';
import PropTypes from 'prop-types';

class SuggestionBox extends React.Component {
    static propTypes = {
        onChange           : PropTypes.func.isRequired,
        showSuggestions    : PropTypes.bool.isRequired,
        name               : PropTypes.string.isRequired,
        placeholder        : PropTypes.string,
        id                 : PropTypes.string,
        label              : PropTypes.string,
        suggestions        : PropTypes.objectOf(PropTypes.array),
        suggestionRenderers: PropTypes.shape({
            type: PropTypes.func,
        }),
    };

    /**
     * @param {*} props
     */
    constructor(props) {
        super(props);

        this.onKeyDownInput = this.onKeyDownInput.bind(this);
        this.storeInputRef  = this.storeInputRef.bind(this);
    }

    /**
     */
    componentWillMount() {
        this.setState({
            suggestionRefs: {}
        });

        this.setHighlightedIndex(-1)
            .setSuggestionCount(this.props);
    }

    /**
     * @param {object} nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setHighlightedIndex(-1)
            .setSuggestionCount(nextProps);
    }

    /**
     * @returns {SuggestionBox}
     */
    setSuggestionCount(props) {
        this.setState({
            suggestionCount: this.suggestionsCount(props)
        });

        return this;
    }

    /**
     * @param {number} index
     * @returns {SuggestionBox}
     */
    setHighlightedIndex(index) {
        this.setState({
            highlightedIndex: index,
        });

        return this;
    }

    /**
     * @param {Number} index
     * @returns {boolean}
     */
    isHighlighted(index) {
        return this.state.highlightedIndex === index;
    }

    /**
     * We want indices assigned to suggestions for highlighting
     * Due to nesting within types we'll iterate over each to add them
     *
     * @param {*} suggestions
     * @returns {*}
     */
    assignIndiciesToSuggestions(suggestions = {}) {
        const suggestionTypes = Object.keys(suggestions);
        const result          = {};
        let index             = 0;

        suggestionTypes.forEach((type) => {
            const suggestionsForType = suggestions[type];

            result[type] = suggestionsForType.map(
                suggestion => Object.assign(suggestion, {index: index++})
            );
        });

        return result;
    }

    /**
     * @param {*} suggestions
     * @returns {Array}
     */
    renderSuggestionsByType(suggestions = {}) {
        const suggestionsToRender = this.assignIndiciesToSuggestions(suggestions);
        const suggestionTypes     = Object.keys(suggestionsToRender);
        const renderedSuggestions = [];

        suggestionTypes.forEach((type) => {
            if (!this.props.suggestionRenderers[type]) {
                throw Error(`Missing renderer for suggestion type: ${type}`);
            }

            const suggestionsForType = suggestions[type];

            renderedSuggestions.push(
                this.props.suggestionRenderers[type](
                    suggestionsForType,
                    this.isHighlighted.bind(this),
                    this.onKeyDownSuggestion
                )
            );
        });

        return renderedSuggestions;
    }

    /**
     * @param {SyntheticEvent} event
     * @returns {SuggestionBox}
     */
    onKeyDownInput(event) {
        if (!event.key) {
            return this;
        }

        const key             = event.key.toLowerCase();
        const suggestionCount = this.state.suggestionCount;
        let highlightedIndex  = this.state.highlightedIndex;

        if (key === 'arrowdown') {
            if (highlightedIndex < suggestionCount - 1) {
                this.setHighlightedIndex(highlightedIndex + 1);
            }
        }

        if (key === 'arrowup') {
            if (highlightedIndex >= 0) {
                return this.setHighlightedIndex(highlightedIndex - 1);
            }
        }

        if (key === 'enter' && this.isASuggestionHighlighted()) {
            event.preventDefault();
            this.selectSuggestion();
        }

        return this;
    }

    /**
     * @returns {SuggestionBox}
     */
    selectSuggestion() {
        const suggestionTypes = Object.keys(this.props.suggestions);

        suggestionTypes.forEach((type) => {
            const suggestionsForType = this.props.suggestions[type];

            const highlightedSuggestion = suggestionsForType.find(
                suggestion => suggestion.index === this.state.highlightedIndex
            );

            if (highlightedSuggestion) {
                window.location = highlightedSuggestion.url;
            }
        });

        return this;
    }

    /**
     * @returns {boolean}
     */
    isASuggestionHighlighted() {
        return this.state.highlightedIndex >= 0 &&
            this.state.highlightedIndex <= this.state.suggestionCount;
    }

    /**
     * @returns {number}
     */
    suggestionsCount(props) {
        const suggestions     = props.suggestions;
        const suggestionTypes = Object.keys(suggestions);

        let suggestionCount = 0;

        suggestionTypes.forEach(type => suggestionCount += suggestions[type].length);

        return suggestionCount;
    }

    /**
     * @param ref
     */
    storeInputRef(ref) {
        this.input = ref;
    }

    render() {
        const {label, id, placeholder, suggestions, name, onChange} = this.props;

        return (
            <div className="suggestion-box">
                <label className="suggestion-box__label">
                    <span className="suggestion-box__label-text">{ label }</span>
                    <input
                        ref={this.storeInputRef}
                        className="suggestion-box__input"
                        type="search"
                        name={name}
                        id={id}
                        placeholder={placeholder}
                        onChange={onChange}
                        onKeyDown={this.onKeyDownInput}
                    />
                </label>

                {
                    this.props.showSuggestions &&
                    <ul className="suggestion-box__results">
                        <li className="suggestion-box__result">
                            {
                                this.renderSuggestionsByType(suggestions, this.state.highlightedIndex)
                            }
                        </li>
                    </ul>
                }
            </div>
        );
    }
}

export default SuggestionBox;
